import { currentLang } from "@kit/lang";
import tr from "./tr.json";
import en from "./en.json";

type Dict = Record<string, string>;
const dicts: Record<string, Dict> = { tr, en };

/** Mozaik's language: the shared arcade choice (?lang= → launcher/hub preference → browser), TR or EN. */
export const lang = currentLang();

export function t(key: string, vars: Record<string, string | number> = {}): string {
  const s = dicts[lang]?.[key] ?? dicts.tr?.[key] ?? key;
  return s.replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? `{${k}}`));
}
